<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                          :wrapper-col="wrapperCol">
                <p class="form_sub_title">基础信息</p>
                <a-form-model-item ref="rolecode" label="用户名称" prop="username">
                    <a-select v-if="is_vue_task && is_add" v-model="record.uid" show-search placeholder="请选择">
                        <a-select-option v-for="(item) in userlist" :key="item.uid" v-model="item.uid">
                            {{ item.username + '【' + item.nickname + '】' + item.uid }}
                        </a-select-option>
                    </a-select>
                    <span class="form_span" v-else>{{ record.username }}</span>
                </a-form-model-item>
                <a-form-model-item ref="status" label="平台编码" prop="status">
                    <span class="form_span">{{ record.platfromcode }}</span>
                </a-form-model-item>
                <a-form-model-item ref="rolecode" label="选择角色" prop="rolecode">
                    <div>
                        <commonselecter :modalState="modalState" @onModalHide="handleSelecterHide"></commonselecter>
                        <a-button @click="handleSelecterShow">选择角色</a-button>
                    </div>
                    <!-- 权限列表 -->
                    <a-table :columns="columns_role1" :data-source="roles" :loading="tLoading1" :pagination="false"
                             rowKey="rolecode">
                    </a-table>
                </a-form-model-item>
                <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>


        </a-card>
    </div>

</template>
<script>
// import {mapState} from "vuex";

import commonselecter from '../../../components/CommonSelecter'

const m_title = {
    'adduserrole': '新增用户角色',
    'detailuserrole': '查看用户角色',
    'edituserrole': '编辑用户角色',
};
const columns_role1 = [
    {
        title: '角色编码',
        dataIndex: 'rolecode',
        align: 'center',
        width: 150
    },
    {
        title: '角色名称',
        dataIndex: 'rolename',
        align: 'center',
        width: 150
    }
];
export default {
    data() {
        return {
            tLoading1: false,
            columns_role1,
            modalState: {
                title: '选择角色',//选择器标题
                isShow: false,
                rowsType: 'checkbox',//checkbox 多选  radio 单选
                selectkeys: undefined,
                filterAppcode: "rolecode",//已选择key数组  [123,456]
                keyname: 'keyword',//唯一主键key
                // searchKey: 'rolecode',//搜索条件键值
                sc_params: {},
                selectedRowKeys: [],
                requestType: 'ums/searchRoleConfigPage',
                columns: [
                    {
                        title: '角色编码',
                        dataIndex: 'rolecode',
                        align: 'center',
                    },
                    {
                        title: '角色名称',
                        dataIndex: 'rolename',
                        align: 'center',
                    }
                ]
            },
            labelCol: {span: 3},
            wrapperCol: {span: 14},
            rules: {
                name: [
                    {required: true, message: '请输入角色名称', trigger: 'blur'},
                    {max: 50, message: '不能超过50位', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            formItemLayout: 'horizontal',
            c_title: '',
            is_vue_task: true,
            is_add: false,
            record: {},
            syslist: [],
            userlist: [],
            roles: []
        };
    },
    methods: {

        roleDate() {
            let roles = []
            let that = this
            let roleData = that.syslist
            let rolecode = that.record.rolecodes.split(",")
            for (let code of rolecode) {
                let roleItem = roleData.filter((item) => {
                    if (item.rolecode == code) {
                        return item;
                    }
                });
                if (roleItem.length > 0) {
                    roles.push(roleItem[0])
                }
            }
            that.tLoading1 = true
            that.roles = roles
            that.tLoading1 = false
        },
        handleSelecterShow() {
            this.modalState.sc_params.platfromcode = this.record.platfromcode;
            this.selectedRowKeys = this.record.rolecodes ? [this.record.rolecodes] : [];
            this.modalState.selectkeys = this.record.rolecodes ? this.record.rolecodes.split(",") : [];
            this.modalState.isShow = true;
        },
        handleSelecterHide: function (result) {
            this.modalState.isShow = false;
            console.log(result)
            if (result) {
                let resultStr = []
                for (let index = 0; index < result.length; index++) {
                    resultStr.push(result[index].rolecode)
                }
                this.record.rolecodes = resultStr.join(",")
                this.tLoading1 = true
                this.roles = result
                this.tLoading1 = false
            }

        },
        getSearchRoleConfig(platfromcode) {
            let c_params = {
                platfromcode: platfromcode,
                urlparams: false,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/searchRoleConfig",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.syslist = res.data.data;
                this.roleDate();
            })
        },
        getSearchUserList() {
            let c_params = {
                userstate: 1,
                urlparams: false,
                pageSize: 9999,
            }
            this.tLoading = true;
            this.$store.dispatch({
                type: "ums/searchUserList",
                params: c_params
            }).then((res) => {
                console.log(res);
                this.userlist = res.data.data.list;
            })
        },


        onSelect() {
        },
        onCheck() {
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    //编辑
                    this.$store
                        .dispatch({
                            type: "ums/updateUserRole",
                            params: this.record
                        })
                        .then((response) => {
                            console.log(response)
                            this.handleCancel();
                            this.confirmLoading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

    },
    mounted() {
        const {query, params} = this.$route;
        this.c_title = m_title[params.action]
        let that = this
        if (query.platfromcode == '') {
            alert("请选择平台")
            return false
        }
        that.record.platfromcode = query.platfromcode
        if (params.action != "adduserrole") {
            this.$store.dispatch({
                type: "ums/searchUserRolesByUser",
                params: query,
                showMsg: false
            }).then((res) => {
                that.record = res.data.data.list[0]
                that.getSearchRoleConfig(query.platfromcode);
            })
        }
        that.is_vue_task = params.action != "detailuserrole"
        that.is_add = params.action == "adduserrole"

        if (this.is_add) {
            this.getSearchUserList()
        }

    }, components: {
        commonselecter
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-right: 40px;
}

.form_span {
    font-size: 14px;
    font-weight: bolder;
}

.form_sub_title {
    font-weight: bold;
}
</style>
